import axios from "axios";

import { IP } from "../utils/Host";


export function dragDropProcesGrupaOprawaGant(id_drag_grupa_proces,id_drop_grupa_proces,refreshGantAll) {


  
  axios
  .get(IP + "drag_drop_proces_grupa_oprawa/"+id_drag_grupa_proces+"/"+id_drop_grupa_proces)
    .then((res) => {
refreshGantAll();

    });
}
